import { gql } from "@apollo/client";
import { DROPDOWN_LIST_PGA_FORM, FRAGMENT_PRICING_LIST_DTO } from "./fragments";

export const GET_NOTIFICATION_HUB_TOKEN = gql`
  query {
    getTokenForNotificationHub {
      hubToken
    }
  }
`;

export const GET_ALERTS_FOR_CMS = gql`
  query getAlertsForCms($skip: Int, $pageSize: Int, $alertType: Int) {
    getAlertsForCms(skip: $skip, take: $pageSize, where: { alertType: { eq: $alertType } }) {
      items {
        alertId
        title
        alertStatus
        createdDateTime
        sendDateTime
        totalAlert
        totalOpened
      }
      totalCount
    }
  }
`;

export const GET_AUTO_ALERTS_FOR_CMS = gql`
  query GetAutoAlertsForCms($skip: Int, $pageSize: Int, $alertType: Int) {
    getAutoAlertsForCms(skip: $skip, take: $pageSize, where: { alertType: { eq: $alertType } }) {
      items {
        alertId
        title
        alertStatus
        createdDateTime
        sendDateTime
        totalOpened
        producerId
        tradingName
        holdingNumber
      }
      totalCount
    }
  }
`;

export const GET_ALERTS_DETAIL_FOR_CMS = gql`
  query getAlertDetailForCms($input: GetAlertDetailForCmsRequestInput) {
    getAlertDetailForCms(getAlertDetailForCmsRequestInput: $input) {
      responseCode
      errorCode
      errorMessage
      title
      sendDateTime
      content
    }
  }
`;

export const DOWNLOAD_RECIPIENT_LIST = gql`
  query downloadRecipientList($input: DownloadRecipientListRequestInput) {
    downloadRecipientList(downloadRecipientListRequestInput: $input) {
      responseCode
      errorCode
      errorMessage
      fileName
    }
  }
`;

export const GET_DOCUMENT_HUB_FILE = gql`
  query getDocumentHubFile($getDocumentHubFileInput: GetDocumentHubFileRequestInput) {
    getDocumentHubFile(getDocumentHubFileInput: $getDocumentHubFileInput) {
      totalPages
      totalCount
      files {
        documentId
        title
        subTitle
        tags
        fileName
        createdDate
        createdByUserName
        createdByUserEmail
      }
    }
  }
`;

export const GET_FAS_MEMBERSHIP = gql`
  query getFASMembershipList($input: GetFASMembershipsRequestInput) {
    getFASMemberships(input: $input) {
      responseCode
      errorCode
      errorMessage
      fass {
        certifier
        memberStatus
        certStatus
        scheme
        holdingNo
        memberNo
        renewal
        grace
        mandatory
        override
        notes
      }
    }
  }
`;

export const GET_FAS_MEMBERSHIP_BY_ID = gql`
  query getFASMembershipDetail($input: GetFASMembershipDetailRequestInput) {
    getFASMembershipDetail(input: $input) {
      responseCode
      errorCode
      errorMessage
      fas {
        producerId
        scheme
        holdingNo
        certifier
        memberStatus
        certStatus
        memberNo
        renewal
        grace
        mandatory
        notes
        override
      }
    }
  }
`;

export const GET_PRODUCERS_FOR_CMS = gql`
  query getProducersForCms($input: GetProducerForCmsRequestInput) {
    getProducersForCms(input: $input) {
      producerDto {
        producerId
        email
        active
        holdingNumber
        country
        lastLoginDatetime
        accountStatus
      }
      totalCount
    }
  }
`;

export const GET_PRODUCER_BY_ID = gql`
  query getProducerCmsById($input: GetProducerCmsByIdRequestInput) {
    getProducerCmsById(input: $input) {
      producerCmsDto {
        producerId
        name
        holdingNo
        accType
        active
        contact
        linkedAcc
        terms
        county
        postCode
        address1
        address2
        address3
        address4
        geogarea
        mobile
        telephone1
        emailAddress
        alternateEmailAddress
        certNo
        herdPrefix
        prodType
        enrolmentDate
        flockNo
        eligibleForExport
        vat
        vatReg
        baseCurrency
        notes
        collectionCentreCostPerHead
        holdings {
          holdingId
          holdingNo
          name
          address1
          address2
          address3
          address4
          postCode
          isPrimary
        }
      }
    }
  }
`;

export const GET_HOLDING_LIST = gql`
  query getHoldings($input: GetHoldingsRequestInput) {
    getHoldings(input: $input) {
      holdings {
        holdingId
        holdingNo
        name
        address1
        address2
        address3
        address4
        postCode
        isPrimary
        totalCount
      }
      responseCode
      errorCode
      errorMessage
    }
  }
`;

export const SEARCH_PRODUCER_LIST = gql`
  query searchProducers($input: SearchProducerRequestInput) {
    searchProducers(input: $input) {
      producers {
        uniqueIdentifier
        producerId
        producerName
        producerType
        holdingNo
        address
        address2
        address3
        address4
        postCode
        countyName
        telephone
        herdNo
        flockNo
        email
        mobileNo
        linkedAcc
      }
      totalCount
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_PRODUCER_LAST_BOOKING = gql`
  query getProducerLastBooking($input: GetProducerLastBookingRequestInput) {
    getProducerLastBooking(input: $input) {
      producerInfo {
        producerId
        lastBookingDate
        lastBookingQuantity
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_CMS_REPORT_FOR_ADMIN = gql`
  query getCmsReportForAdmin($input: GetCmsReportForAdminRequestInput) {
    getCmsReportForAdmin(getCmsReportForAdminRequestInput: $input) {
      items {
        reportId
        name
        typeId
        typeName
        startDate
        endDate
        country
        site
        species
        createdDate
        noteProgress
        preference
        pgaUpdatedBy
        pgaStatus
        producers
      }
      totalCount
    }
  }
`;

export const GET_USERS_FOR_CMS = gql`
  query getUserList($input: GetUserListRequestInput) {
    getUserList(getUserListRequestInput: $input) {
      responseCode
      totalPage
      totalCount
      users {
        userId
        name
        email
        jobTittle
        active
        abbs {
          abb
          abbName
          isDefault
        }
        roleIds {
          roleId
          name
        }
        lastRoleUpdated
        lastRoleUpdatedBy
        folders {
          id
          name
        }
      }
    }
  }
`;

export const GET_ROLE_FOR_CMS = gql`
  query getRoles($skip: Int, $take: Int, $filters: PersonalRoleDtoFilterInput) {
    getRoles(skip: $skip, take: $take, where: $filters) {
      totalCount
      items {
        roleId
        name
        active
        description
        updatedBy
        updatedDate
        displayName
        isSystemAdmin
      }
    }
  }
`;

export const SEARCH_ROLES_FOR_CMS = gql`
  query searchRoles($input: GetRoleSiteRequestInput) {
    searchRoles(input: $input) {
      responseCode
      roles {
        roleId
        name
      }
      canViewNotYetSupplied
    }
  }
`;

export const GET_CMS_REPORT_EXECUTION = gql`
  query getCmsReportExecution(
    $getCmsReportExecutionRequestInput: GetCmsReportExecutionRequestInput
  ) {
    getCmsReportExecution(getCmsReportExecutionRequestInput: $getCmsReportExecutionRequestInput) {
      errorCode
      errorMessage
      responseCode
      fileName
      reportTitle
      totalCount
      totalPage
      activityReport {
        producerId
        tradingName
        farmName
        loggedInDate
        county
        buyer
        userType
        sites
      }
      registrationReport {
        producerId
        tradingName
        farmName
        registeredDate
        county
      }
      killDataReport
      marketingReport {
        producerId
        tradingName
        subscribeEmail
        subscribeCall
        subscribePost
        subscribeText
      }
    }
  }
`;

export const GET_PRODUCERS_FOR_BUYER = gql`
  query getProducersForBuyer($input: GetProducerForBuyerRequestInput) {
    getProducersForBuyer(input: $input) {
      producerDto {
        producerId
        fullName
        tradingName
        email
        address1
        holdingNumber
        isFavorite
        lastLoginDatetime
        active
        accountStatus
      }
      totalCount
    }
  }
`;

export const GET_AUTO_TOKEN = gql`
  query generateAutoTokenQuery($input: GenerateAutoTokenRequestInput) {
    generateAutoToken(input: $input) {
      errorCode
      errorMessage
      responseCode
      autoLoginUrl
    }
  }
`;

export const GET_LIST_PRODUCER_INFO_TO_VALIDATION = gql`
  query getListProducerInfoToValidation(
    $getListProducerInfoToValidationInput: GetListProducerInfoToValidationInput!
  ) {
    getListProducerInfoToValidation(
      getListProducerInfoToValidationInput: $getListProducerInfoToValidationInput
    ) {
      responseCode
      errorCode
      errorMessage
      isValidAll
      producerInfoToValidation {
        producerId
        producerName
        isValid
        producerErrorType
      }
    }
  }
`;

export const GET_CATEGORIES_FOR_DOCUMENT_HUB = gql`
  query getCategoriesForDocumentHub {
    getCategoriesForDocumentHub {
      categoryId
      categoryName
      orderIndex
    }
  }
`;

export const GET_SITE_AVAILABLE = gql`
  query GetSitesAvailable {
    getSitesAvailable {
      siteId
      siteAbb
    }
  }
`;

export const GET_AB_SITE_AVAILABLE = gql`
  query GetAbSitesAvailable {
    getAbSitesAvailable {
      siteId
      siteAbb
      uniqueIdentifier
      isDefault
    }
  }
`;

export const GET_ABB_SITE_AVAILABLE_WITH_SPECIES = gql`
  query GetAbSitesAvailable {
    getAbSitesAvailable {
      siteId
      siteAbb
      species
      uniqueIdentifier
      isDefault
    }
  }
`;

export const GET_ABB_SITE_HOLDING_NO_CONFIG = gql`
  query GetAbSitesHoldingNoConfig {
    getAbSitesAvailable {
      siteId
      isEnableHoldingNo
    }
  }
`;

export const GET_BOOKING_FEATURE_PLACEMENTS = gql`
  query GetBookingFeaturePlacements {
    getBookingFeaturePlacements {
      responseCode
      errorCode
      errorMessage
      items {
        id
        code
        name
      }
    }
  }
`;

export const GET_CMS_REPORT_TYPES = gql`
  query getCmsReportTypes {
    getCmsReportTypes {
      typeId
      typeName
      description
      orderIndex
    }
  }
`;

export const GET_CMS_FAS = gql`
  query getFASList {
    getFASList {
      responseCode
      errorCode
      errorMessage
      fass {
        fas
        species
        descr
        orderPosition
        gracePeriod
        organic
        schemeId
        enterpriseId
      }
    }
  }
`;

export const GET_CMS_FAS_DETAIL_BY_ID = gql`
  query getFASDetail($input: GetFASDetailRequestInput) {
    getFASDetail(input: $input) {
      responseCode
      errorCode
      errorMessage
      fas {
        fas
        descr
        species
        orderPosition
        gracePeriod
        organic
        schemeId
        enterpriseId
      }
    }
  }
`;
export const GET_SPECIES_BY_FAS = gql`
  query getSpeciesList($input: GetSpeciesRequestInput) {
    getSpeciesList(input: $input) {
      responseCode
      errorCode
      errorMessage
      species {
        uniqueIdentifier
        species
        descr
      }
    }
  }
`;
export const CHECK_STATUS_CMS_REPORT_GENERATING = gql`
  query checkStatusCmsReportGenerating {
    checkStatusCmsReportGenerating {
      responseCode
      errorCode
      errorMessage
      isGenerating
      reportType
    }
  }
`;
export const GET_MAINTENANCE_STATUS = gql`
  query getMaintenanceStatus {
    getMaintenanceStatus {
      errorCode
      errorMessage
      responseCode
      isUnderMaintenance
    }
  }
`;

export const GET_AGREEMENT_FORMS_LIST = gql`
  query getAgreementFormsList(
    $getAgreementFormsListRequestInput: GetAgreementFormsListRequestInput
  ) {
    getAgreementFormsList(getAgreementFormsListInput: $getAgreementFormsListRequestInput) {
      errorCode
      errorMessage
      responseCode
      forms {
        producerId
        agreementFormId
        tradingName
        holdingNumber
        lastUpdated
        expiredIn
        expirationDate
        sites
        isReviewed
        lastUpdatedRole
        formYear
        flagNotes
        isUpdatedByAdmin
      }
      totalCountCurrentTab
      totalNotStarted
      totalDraft
      totalSubmitted
      totalApproved
    }
  }
`;

export const GET_DROPDOWN_VALUES_PGA_FORM = gql`
  ${DROPDOWN_LIST_PGA_FORM}
  query getDropdownValuesPGAForm {
    OrganicSchemes: getOrganicSchemes {
      ...dropdownListPGAForm
    }
    FarmAssuraceSchemes: getFarmAssuraceSchemes {
      ...dropdownListPGAForm
    }
    EnvironmentalSchemes: getEnvironmentalSchemes {
      ...dropdownListPGAForm
    }
    BeddingMaterials: getBeddingMaterials {
      ...dropdownListPGAForm
    }
    ForecastedTypesCattle: getForecastedTypesForCattle {
      ...dropdownListPGAForm
    }
    ForecastedTypesSheep: getForecastedTypesForSheep {
      ...dropdownListPGAForm
    }
    SoyaOrigins: getSoyaOrigins {
      ...dropdownListPGAForm
    }
    PalmOrigins: getPalmOrigins {
      ...dropdownListPGAForm
    }
    SheepBreeds: getSheepBreeds {
      ...dropdownListPGAForm
    }
    FarmEnterprises: getFarmEnterprises {
      ...dropdownListPGAForm
    }
    FarmVetPractices: getFarmVetPractices {
      ...dropdownListPGAForm
    }
    SemenSuppliers: getSemenSuppliers {
      ...dropdownListPGAForm
    }
    BioDiversities: getBioDiversities {
      ...dropdownListPGAForm
    }
    CarbonCalculators: getCarbonCalculators {
      ...dropdownListPGAForm
    }
    GetTenYearsUntilPGAFormCreatedDate: getTenYearsUntilPGAFormCreatedDate {
      ...dropdownListPGAForm
    }
    CarbonReductionPlans: getCarbonReductionPlans {
      ...dropdownListPGAForm
    }
    CarbonFootprintUnits: getCarbonFootprintUnits {
      ...dropdownListPGAForm
    }
    GetInterestedInOptions: getInterestedInOptions {
      ...dropdownListPGAForm
    }
  }
`;

export const GET_DROPDOWN_VALUES_PGA_FORM_2025 = gql`
  ${DROPDOWN_LIST_PGA_FORM}
  query getDropdownValuesPGAForm {
    OrganicSchemes: getOrganicSchemes {
      ...dropdownListPGAForm
    }
    FarmAssuraceSchemes: getFarmAssuraceSchemes {
      ...dropdownListPGAForm
    }
    EnvironmentalSchemes: getEnvironmentalSchemes {
      ...dropdownListPGAForm
    }
    BeddingMaterials: getBeddingMaterials {
      ...dropdownListPGAForm
    }
    ForecastedTypesCattle: getForecastedTypesForCattle {
      ...dropdownListPGAForm
    }
    ForecastedTypesSheep: getForecastedTypesForSheep {
      ...dropdownListPGAForm
    }
    SoyaOrigins: getSoyaOrigins {
      ...dropdownListPGAForm
    }
    PalmOrigins: getPalmOrigins {
      ...dropdownListPGAForm
    }
    SheepBreeds: getSheepBreeds {
      ...dropdownListPGAForm
    }
    FarmEnterprises: getFarmEnterprises {
      ...dropdownListPGAForm
    }
    FarmVetPractices: getFarmVetPractices {
      ...dropdownListPGAForm
    }
    SemenSuppliers: getSemenSuppliers {
      ...dropdownListPGAForm
    }
    BioDiversities: getBioDiversities {
      ...dropdownListPGAForm
    }
    CarbonCalculators: getCarbonCalculators {
      ...dropdownListPGAForm
    }
    GetTenYearsUntilPGAFormCreatedDate: getTenYearsUntilPGAFormCreatedDate {
      ...dropdownListPGAForm
    }
    CarbonReductionPlans: getCarbonReductionPlans {
      ...dropdownListPGAForm
    }
    CarbonFootprintUnitsNew: getCarbonFootprintUnitsNew {
      ...dropdownListPGAForm
    }
    GetInterestedInOptions: getInterestedInOptions {
      ...dropdownListPGAForm
    }
  }
`;

export const GET_DROPDOWN_VALUES_PGA_FORM_2026 = gql`
  ${DROPDOWN_LIST_PGA_FORM}
  query getDropdownValuesPGAForm {
    OrganicSchemes: getOrganicSchemes {
      ...dropdownListPGAForm
    }
    FarmAssuraceSchemes: getFarmAssuraceSchemes {
      ...dropdownListPGAForm
    }
    EnvironmentalSchemes: getEnvironmentalSchemes {
      ...dropdownListPGAForm
    }
    BeddingMaterials: getBeddingMaterials {
      ...dropdownListPGAForm
    }
    ForecastedTypesCattle: getForecastedTypesForCattle {
      ...dropdownListPGAForm
    }
    ForecastedTypesSheep: getForecastedTypesForSheep {
      ...dropdownListPGAForm
    }
    SoyaOrigins: getSoyaOrigins {
      ...dropdownListPGAForm
    }
    PalmOrigins: getPalmOrigins {
      ...dropdownListPGAForm
    }
    SheepBreeds: getSheepBreeds {
      ...dropdownListPGAForm
    }
    FarmEnterprises: getFarmEnterprises {
      ...dropdownListPGAForm
    }
    FarmVetPractices: getFarmVetPractices {
      ...dropdownListPGAForm
    }
    SemenSuppliers: getSemenSuppliers {
      ...dropdownListPGAForm
    }
    BioDiversities: getBioDiversities {
      ...dropdownListPGAForm
    }
    CarbonCalculators: getCarbonCalculators {
      ...dropdownListPGAForm
    }
    GetTenYearsUntilPGAFormCreatedDate: getTenYearsUntilPGAFormCreatedDate {
      ...dropdownListPGAForm
    }
    CarbonReductionPlans: getCarbonReductionPlans {
      ...dropdownListPGAForm
    }
    CarbonFootprintUnitsNew: getCarbonFootprintUnitsNew {
      ...dropdownListPGAForm
    }
    GetInterestedInOptions: getInterestedInOptions {
      ...dropdownListPGAForm
    }
    GetInterestOptions: getInterestOptions {
      ...dropdownListPGAForm
    }
    GetLifeStagingForCattle: getLifeStagingForCattle {
      ...dropdownListPGAForm
    }
    GetMedicineUsages: getMedicineUsages {
      ...dropdownListPGAForm
    }
    GetMembershipBodies: getMembershipBodies {
      ...dropdownListPGAForm
    }
    GetLifeStagingForSheep: getLifeStagingForSheep {
      ...dropdownListPGAForm
    }
  }
`;

export const GET_DROPDOWN_VALUES_PGA_FORM_REVIEW = gql`
  ${DROPDOWN_LIST_PGA_FORM}
  query getDropdownValuesPGAForm {
    OrganicSchemes: getOrganicSchemes {
      ...dropdownListPGAForm
    }
    FarmAssuraceSchemes: getFarmAssuraceSchemes {
      ...dropdownListPGAForm
    }
    EnvironmentalSchemes: getEnvironmentalSchemes {
      ...dropdownListPGAForm
    }
  }
`;

export const GET_COUNTIES = gql`
  query GetCounties {
    getCounties {
      responseCode
      errorCode
      errorMessage
      counties {
        countyId
        countyName
      }
    }
  }
`;

export const GET_AGREEMENT_FORM_FOR_REVIEW = gql`
  query getAgreementFormForReview(
    $getAgreementFormForReviewRequestInput: GetAgreementFormForReviewRequestInput
  ) {
    getAgreementFormForReview(
      getAgreementFormForReviewInput: $getAgreementFormForReviewRequestInput
    ) {
      errorCode
      errorMessage
      responseCode
      agreementStep1 {
        contactName
        tradingName
        paymentAddressLine1
        addressLine2
        addressLine3
        addressLine4
        postCode
        county
        countryName
        primaryEmailAddress
        alternateEmailAddress
        mainContactNumber
        additionalContactNumber
      }
      agreementStep2 {
        fasMembershipNo
        farmAssuraceSchemeId
        farmAssuraceOtherValues
        primaryHoldingNumber
        additionalHoldingNumber
        organicProducer
        organicSchemeId
        organicSchemeNumber
        organicSchemeOtherValue
        environmentalScheme
        environmentalSchemeId
        environmentalSchemeOtherValue
      }
      differentFields
      approvedFields
      isApprovedAll
    }
  }
`;

export const DOWNLOAD_AGREEMENT_FORMS_LIST = gql`
  query getAgreementFormsList(
    $getAgreementFormsListRequestInput: GetAgreementFormsListRequestInput
  ) {
    getAgreementFormsList(getAgreementFormsListInput: $getAgreementFormsListRequestInput) {
      errorCode
      errorMessage
      responseCode
      fileName
    }
  }
`;

export const GET_PGA_FIELD_REVIEW_STATUS = gql`
  query GetPGAFieldReviewStatus(
    $getPGAFieldReviewStatusRequestInput: GetPGAFieldReviewStatusRequestInput
  ) {
    getPGAFieldReviewStatus(getPGAFieldReviewStatusInput: $getPGAFieldReviewStatusRequestInput) {
      errorCode
      errorMessage
      responseCode
      fieldStatus {
        currentValue
        prevValue
        approveStatus
      }
    }
  }
`;

export const GET_CURRENT_AGREEMENT_FORM_CMS = gql`
  query getCurrentAgreementFormCms(
    $getCurrentAgreementFormInput: GetCurrentAgreementFormRequestInput
  ) {
    getCurrentAgreementFormCms(getCurrentAgreementFormInput: $getCurrentAgreementFormInput) {
      responseCode
      errorCode
      errorMessage

      agreementFormId
      producerId
      producerName
      currentStep
      progressStatusId
      progressStatusName
      displayStep

      lastUpdatedRole
      agreementStep1Dto {
        contactName
        tradingName
        paymentAddressLine1
        addressLine2
        addressLine3
        addressLine4
        postCode
        county
        countryName
        primaryEmailAddress
        alternateEmailAddress
        mainContactNumber
        additionalContactNumber
      }
      agreementStep2Dto {
        fasMembershipNo
        farmAssuraceSchemeId
        farmAssuraceOtherValues
        primaryHoldingNumber
        additionalHoldingNumber
        organicProducer
        organicSchemeNumber
        organicSchemeId
        organicSchemeOtherValue
        environmentalScheme
        environmentalSchemeId
        environmentalSchemeOtherValue
        uploadAntibioticData
        medicineUsage
        howMedicineUsageRecord
        medicineUsageId
        medicineUsageOtherValue
        farmSize
        farmSizeUnit
        membershipBodyIds
        membershipBodyOtherValue
      }
      agreementStep3Dto {
        finishCattleForSlaughter
        supplyCattle
        herdPrefix
        homeBredCattle
        cattleToFinish
        cattleOutdoorsInWinter
        beddingMaterialId
        beddingMaterialOtherValue
        numbersPurchasedObject
        forecastedSupplyObject
        approveFinishingUnit
        unitGrazing
        grassDietPercentage
        feedInfoObject
        feedContainSoya
        soyaFeedingObject
        feedContainPalmOil
        palmFeedingObject
        soyaFeedingForCattle
        soyaFeedingForCattleObjects {
          certifiedDeforestationFree
          details
        }
        palmFeedingForCattle
        palmFeedingForCattleObjects {
          certifiedDeforestationFree
          details
        }
        regularWeighingCattle
        interestedOptionsIds
        lifeStagingForCattleIds
      }
      agreementStep4Dto {
        finishLambForSlaughter
        supplySheep
        flockNumber
        additionalFlockNumber
        flockSize
        eweBreedIds
        eweOther
        ramBreedIds
        ramOther
        forecastedSupplyObject
        geneticLambs
        feedInfoObject
        feedContainSoya
        soyaFeedingObject
        feedContainPalmOil
        palmFeedingObject
        soyaFeedingForSheep
        palmFeedingForSheep
        soyaFeedingForSheepObjects {
          certifiedDeforestationFree
          details
        }
        palmFeedingForSheepObjects {
          certifiedDeforestationFree
          details
        }
        regularWeighingSheep
        lifeStagingForSheepIds
      }
      agreementStep5Dto {
        additionalFarmEnterprise
        farmEnterpriseIds
        farmEnterpriseOther
        farmVetPractice
        farmVetOtherAdd
        farmVetOtherName
        farmVetOtherPostCode
        farmVetOtherPhoneNo
        useAI
        companySemenSupplyIds
        companySemenSupplyOther
        companyAIServiceIds
        companyAIServiceOther
        financeForWeanedCalves
        interestedInOptions
        interestedInResearchOrProducerGroup
        farmSoftware
        farmSoftwareUse
      }
      agreementStep6Dto {
        biodiversityIds
        bioDiversityOtherValue
        soilManagementPlan
        waterManagementPlan
        renewableEnergy
        measuredCarbonFootprint
        carbonCaculatorId
        carbonCaculatorOtherValue
        carbonFootprintCalculatedYear
        carbonFootprintResultObject
        carbonReductionPlan
        carbonReductionPlanIds
        carbonReductionPlanOtherValue
        interestedInSustainabilityProgramme
        peatExposure
        peatReductionPlan
        sellCarbonCredit
        nutrientManagementPlan
        environmentalInitiatives
        environmentalInitiativeObjects {
          valueId
          details
        }
        governmentEnvironmentalSchemes
        governmentEnvironmentalSchemeObjects {
          countryId
          countryName
          schemes
          orderIndex
        }
        biodiversityPlan
        farmInFloodRiskArea
        useLandApp
      }
    }
  }
`;

export const GET_COUNTRY_BY_COUNTY_ID = gql`
  query GetCountryByCountyId($countyId: String) {
    getCountryByCountyId(countyId: $countyId) {
      responseCode
      errorCode
      errorMessage
      country {
        countryId
        countryName
      }
    }
  }
`;

export const GET_FORECASTED_DATES_CMS = gql`
  query getForecastedDates($producerId: String) {
    getForecastedDates(producerId: $producerId) {
      id
      name
    }
  }
`;

export const CHECK_EDIT_FORM_PERMISSION = gql`
  query checkEditFormPermission(
    $checkEditFormPermissionInput: CheckEditFormPermissionRequestInput
  ) {
    checkEditFormPermission(checkEditFormPermissionInput: $checkEditFormPermissionInput) {
      responseCode
      userEditingEmail
    }
  }
`;

export const CHECK_REVIEW_FORM_PERMISSION = gql`
  query checkReviewFormPermission($input: CheckReviewFormPermissionRequestInput!) {
    checkReviewFormPermission(input: $input) {
      responseCode
      errorCode
      errorMessage
      userReviewingEmail
    }
  }
`;

export const GET_LAST_YEAR_SUPPLY_DATA = gql`
  query getLastYearSupplyData($getLastYearSupplyDataInput: GetLastYearSupplyDataRequestInput) {
    getLastYearSupplyData(getLastYearSupplyDataInput: $getLastYearSupplyDataInput) {
      responseCode
      errorCode
      errorMessage
      lastYearSupplyObject
    }
  }
`;

export const GET_LOT_INFO_EMAIL = gql`
  query getLotInfoEmail($getLotInfoEmailRequestInput: GetLotInfoEmailRequestInput) {
    getLotInfoEmail(input: $getLotInfoEmailRequestInput) {
      errorCode
      errorMessage
      responseCode
      totalCount
      lotInfos {
        producerId
        producerName
        killDate
        remitted
        lotId
        species
        site
        abb
        alternateEmailAddress
        sentEmail
        noOfRecipient
        headCount
        buyer
      }
    }
  }
`;

export const GET_EMAIL_RECIPIENTS = gql`
  query getEmailRecipients($getRecipientsLotEmailRequestInput: GetRecipientsLotEmailRequestInput) {
    getRecipientsLotEmail(input: $getRecipientsLotEmailRequestInput) {
      errorCode
      errorMessage
      responseCode
      recipients {
        email
        sendingTime
      }
    }
  }
`;

export const GET_ADMIN_INFO = gql`
  query getAdminInfo {
    getAdminInfo {
      errorCode
      errorMessage
      responseCode
      adminInfos {
        email
        userId
      }
    }
  }
`;

export const CHECK_PRODUCER_VALID = gql`
  query CheckProducerValid($input: CheckProducerValidRequestInput) {
    checkProducerValid(input: $input) {
      errorCode
      errorMessage
      responseCode
      validProducerInfos {
        producer
        name
        isNotFound
      }
    }
  }
`;

export const GET_CARCASE_DETAILS_PDF = gql`
  query getCarcaseDetailsPdf($getCarcaseDetailsPdfRequestInput: GetCarcaseDetailsPdfRequestInput) {
    getCarcaseDetailsPdf(input: $getCarcaseDetailsPdfRequestInput) {
      errorCode
      errorMessage
      responseCode
      fileName
    }
  }
`;

export const GET_SPEC_ID_CATEGORIES = gql`
  query GetSpecIdCategories {
    getSpecIdCategories {
      id
      name
      values {
        id
        value
      }
    }
  }
`;

export const GET_PRODUCERS_FOR_FARM_GROUP = gql`
  query GetProducersForFarmGroup($input: GetProducersForFarmGroupRequestInput!) {
    getProducersForFarmGroup(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalProducers
      producers {
        producerId
        tradingName
        includedGroupsCount
      }
    }
  }
`;

export const GET_IDEAL_RANGE = gql`
  query GetIdealRange {
    getIdealRange {
      conf {
        id
        value
        orderPos
      }
      fat {
        id
        value
        orderPos
      }
    }
  }
`;

export const GET_GROUP_APPROVERS = gql`
  query GetGroupApprovers {
    getGroupApprovers {
      responseCode
      errorCode
      errorMessage
      groupApprovers {
        userId
        email
      }
    }
  }
`;

export const GET_PRODUCER_GROUPS = gql`
  query GetProducerGroups($input: GetProducerGroupsRequestInput!) {
    getProducerGroups(input: $input) {
      responseCode
      errorCode
      errorMessage
      groups {
        groupId
        groupName
        description
        specIdCategory
        noOfMembers
        createdBy
        createdDateTime
        status
        approverEmail
        approverUserId
        approvedByName
        approvedTime
        publishedTime
        createdById
        submittedBy
        submittedTime
        rejectedBy
        rejectedTime
        rejectedNotes
        editedBy
        editedTime
      }
      totalCount
    }
  }
`;

export const GET_INCLUDED_GROUPS_BY_PRODUCER = gql`
  query GetProducerGroups($input: GetProducerGroupsRequestInput!) {
    getProducerGroups(input: $input) {
      responseCode
      errorCode
      errorMessage
      groups {
        groupId
        groupName
        description
        createdBy
        createdDateTime
        approvedByName
        status
      }
      totalCount
    }
  }
`;

export const GET_GROUP_CREATORS = gql`
  query GetGroupCreators {
    getGroupCreators {
      responseCode
      errorCode
      errorMessage
      groupCreators {
        userId
        displayName
      }
    }
  }
`;

export const GET_SPEC_ID_AND_NAME_CATEGORIES = gql`
  query GetSpecIdCategories {
    getSpecIdCategories {
      id
      name
    }
  }
`;

export const GET_GROUP_INPUTS_STEP_1_FOR_REVIEW = gql`
  query GetGroupInputStep1ForReview($input: GetGroupInputStep1ForReviewRequestInput!) {
    getGroupInputStep1ForReview(input: $input) {
      responseCode
      errorCode
      errorMessage
      step1 {
        groupName
        description
        sites
        specIdCategory
        specIdValues
      }
    }
  }
`;

export const CHECK_FARM_GROUP_STATUS = gql`
  query CheckFarmGroupStatus($input: CheckGroupStatusRequestInput!) {
    checkFarmGroupStatus(input: $input) {
      errorCode
      status
      responseCode
      errorMessage
    }
  }
`;

export const GET_GROUP_INPUTS_STEP_2_FOR_REVIEW = gql`
  query GetGroupInputStep2ForReview($input: GetGroupInputStep2ForReviewRequestInput!) {
    getGroupInputStep2ForReview(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalRows
      producers {
        producerId
        tradingName
      }
    }
  }
`;

export const GET_GROUP_INPUT_STEP_3_FOR_REVIEW = gql`
  query GetGroupInputStep3ForReview($input: GetGroupInputStep3ForReviewRequestInput!) {
    getGroupInputStep3ForReview(input: $input) {
      responseCode
      errorCode
      errorMessage
      step3 {
        bulls {
          weight
          age
          conf
          fat
        }
        steers {
          weight
          age
          conf
          fat
        }
        heifers {
          weight
          age
          conf
          fat
        }
      }
    }
  }
`;

export const GET_BUYER_SITES = gql`
  query GetBuyerSites($input: GetBuyerSitesRequestInput!) {
    getBuyerSites(input: $input) {
      responseCode
      errorCode
      errorMessage
      hasNotYetSupplied
      siteAbbs {
        siteAbb
        siteId
      }
    }
  }
`;

export const GET_ENVIROMENTAL_INITIATIVES = gql`
  query GetEnvironmentalInitiatives {
    getEnvironmentalInitiatives {
      id
      name
      orderIndex
      minYear
      maxYear
    }
  }
`;

export const GET_PRODUCER_DOCUMENTS = gql`
  query GetProducerDocumentsForCms($input: GetProducerDocumentsCmsRequestInput) {
    getProducerDocumentsForCms(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      producerDocuments {
        documentId
        description
        fileName
        sites
        lastUpdatedDatetime
        producerId
        tradingName
        updatedBy
        folderId
        path
      }
    }
  }
`;

export const GET_AUDIT_LOGS_BY_PRODUCER = gql`
  query getAuditLoginLogs($input: AuditLoginLogRequestInput) {
    getAuditLoginLogs(input: $input) {
      errorCode
      errorMessage
      responseCode
      auditLoginLogs {
        producerId
        passwordComparison
        emailComparison
        platform
        loginTime
      }
    }
  }
`;

export const GET_SITES_AVAILABLE = gql`
  query GetSitesAvailable {
    getSitesAvailable {
      siteId
      siteAbb
    }
  }
`;

export const GET_BOOKINGS = gql`
  query getBookings($input: GetBookingRequestInput) {
    getBookings(input: $input) {
      bookings {
        uniqueIdentifier
        producerId
        haulierDescr
        lot
        isOrganic
        movementRestriction
        quantity
        angusQuantity
        notes
        id
        species
        time
        date
        deleted
        tradingName
        address
        buyerUi
        buyerId
        buyerDescr
        haulierUi
        haulierCode
        isWagyu
        isLights
        isSFSFarm
        isWelsh
        isWestCountry
        isArrived
        arrivedQuantity
        featureValues {
          featureId
          value
        }
      }
      bookingSummary {
        daily {
          totalBookings
          totalQuantity
          totalAngus
          organicCount
          organicQuantity
          gamechangerQuantity
          wagyuQuantity
          lightsQuantity
          welshQuantity
          westCountryQuantity
          dailyArrivedQuantity
          dynamicTallies {
            featureId
            featureName
            count
          }
          __typename
        }
        weekly {
          totalBookings
          totalQuantity
          totalAngus
          organicCount
          organicQuantity
          gamechangerQuantity
          wagyuQuantity
          lightsQuantity
          welshQuantity
          westCountryQuantity
          dynamicTallies {
            featureId
            featureName
            count
          }
        }
        lairageCap
        lairageRemainingCap
      }
      bookingCategories {
        code
        name
        quantity
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;
export const GET_BOOKINGS_DETAIL = gql`
  query getBookingDetail($input: GetBookingDetailRequestInput) {
    getBookingDetail(input: $input) {
      bookingInfo {
        producerId
        haulierDescr
        lot
        isOrganic
        quantity
        angusQuantity
        notes
        id
        species
        time
        date
        tradingName
        address
        buyerId
        buyerDescr
        haulierCode
        killDate
        matrixId
        penId
        cost
        deleted
        doa
        dil
        isContractKill
        movementRestriction
        isSFSFarm
        isWagyu
        isLights
        isWelsh
        isWestCountry
        transportCostTypeId
        featureValues {
          featureId
          value
        }
      }
      categories {
        catId
        descr
        quantity
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;
export const SEARCH_BUYER = gql`
  query searchBuyer($input: SearchBuyerRequestInput) {
    searchBuyer(input: $input) {
      responseCode
      errorCode
      errorMessage
      buyers {
        id
        uniqueIdentifier
        descr
      }
    }
  }
`;
export const SEARCH_MATRIX = gql`
  query searchMatrix($input: SearchMatrixRequestInput) {
    searchMatrix(input: $input) {
      responseCode
      errorCode
      errorMessage
      matrixs {
        species
        matrix
        matrixType
        matrixId
        descr
        isDefault
      }
    }
  }
`;
export const SEARCH_TRANSPORTER = gql`
  query searchTransporter($input: SearchTransporterRequestInput) {
    searchTransporter(input: $input) {
      responseCode
      errorCode
      errorMessage
      transporters {
        uniqueIdentifier
        id
        descr
      }
    }
  }
`;
export const GET_PRODUCER_DEFAULT_INFO_FOR_BOOKING = gql`
  query getProducerDefault($input: GetProducerDefaultRequestInput) {
    getProducerDefault(input: $input) {
      producerDefault {
        producerId
        species
        type
        value
        descr
        uniqueIdentifier
        defaultCost
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_ABB_DETAIL_FOR_BOOKING = gql`
  query getAbbDetail($input: GetAbbDetailRequestInput) {
    getAbbDetail(input: $input) {
      abbDetail {
        uniqueIdentifier
        abb
        descr
        cattleCapacity
        sheepCapacity
        organic
        sfsFarm
        wagyu
        lights
        welsh
        westCountry
        movementRestriction
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_PRODUCER_HAULIER_DEFAULT_COST_FOR_BOOKING = gql`
  query getProducerHaulierCostDefault($input: GetProducerHaulierCostDefaultRequestInput) {
    getProducerHaulierCostDefault(input: $input) {
      producerHaulierDefault {
        producerId
        haulierId
        costPerHead
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_CATEGORIES = gql`
  query getCategories($input: GetCategoriesRequestInput) {
    getCategories(input: $input) {
      responseCode
      errorCode
      errorMessage
      categories {
        id
        uniqueIdentifier
        species
        abb
        descr
      }
    }
  }
`;
export const GET_BOOKINGS_RECYCLE_BIN = gql`
  query getBookingRecycleBin($input: GetBookingRecycleBinRequestInput) {
    getBookingRecycleBin(input: $input) {
      bookings {
        producerId
        haulierDescr
        lot
        isOrganic
        quantity
        angusQuantity
        notes
        id
        species
        time
        date
        tradingName
        address
        buyerId
        buyerDescr
        haulierCode
      }
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_BUYER_LIST = gql`
  query searchBuyerInfo($input: SearchBuyerInfoRequestInput) {
    searchBuyerInfo(input: $input) {
      buyers {
        buyerId
        buyerName
        address1
        address2
        postCode
        mobile
        totalRows
      }
      responseCode
      errorCode
      errorMessage
    }
  }
`;
export const GET_BUYER_BY_ID = gql`
  query getBuyerById($input: GetBuyerByIdRequestInput) {
    getBuyerById(input: $input) {
      buyer {
        buyerId
        buyerName
        isDefault
        address1
        address2
        address3
        address4
        postCode
        mobile
        emailAddress
        telephone1
        telephone2
        cattleRatePerHead
        sheepRatePerHead
        matrixType
        updateAt
        updateBy
      }
      responseCode
      errorCode
      errorMessage
    }
  }
`;

export const GET_SYSTEM_DEFAULT_BUYER = gql`
  query getDefaultBuyer($input: GetDefaultBuyerRequestInput) {
    getDefaultBuyer(input: $input) {
      defaultBuyer {
        id
        buyerName
      }
      responseCode
      errorCode
      errorMessage
    }
  }
`;

export const GET_GROUPED_PRODUCERS = gql`
  query GetGroupedProducers($input: GetGroupedProducersRequestInput!) {
    getGroupedProducers(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalProducers
      producers {
        producerId
        tradingName
        emailAddress
        holdingNumber
        includedGroupsCount
      }
    }
  }
`;

export const GET_PRODUCER_MANAGEMENT = gql`
  query getProducerManagement($input: GetProducerManagementRequestInput) {
    getProducerManagement(input: $input) {
      producers {
        producerId
        name
        active
        holdingNo
        county
        active
        postcode
      }
      totalCount
    }
  }
`;

export const GET_PRODUCER_TYPE_LIST = gql`
  query getProducerTypes {
    getProducerTypes {
      responseCode
      errorCode
      errorMessage
      producerTypes {
        prodType
        descr
        collectionCentreFlag
        includeInAutoSpec
        marketFlag
      }
    }
  }
`;

export const GET_LOT_PRICING_LIST = gql`
  query getLots($input: GetLotsRequestInput) {
    getLots(input: $input) {
      responseCode
      errorCode
      errorMessage
      lots {
        species
        lot
        killDate
        netValue
        carcasses
        priced
        pricingComplete
        remitted
        approved
        producerId
        producerName
        buyerName
        holdingNo
        approved
      }
      newCount
      pricedCount
      pricingCompleteCount
      remittedCount
      approvedCount
    }
  }
`;

export const GET_LOTS_IMPORT = gql`
  query getLotsImport($input: GetKillDataLotsRequestInput) {
    getLotsImport(input: $input) {
      responseCode
      errorCode
      errorMessage
      lotsToImport {
        lot
        producerId
        producerName
        scanned
        stunned
        graded
        booked
        delivered
        reconStatus
        availableSelection
        status
      }
      importedLots {
        lot
        producerId
        producerName
        priced
        remitted
        newDataAvailable
      }
    }
  }
`;

export const GET_LOTS_EXPORT = gql`
  query getLotsExport($input: GetExportLotsRequestInput) {
    getLotsExport(input: $input) {
      responseCode
      errorCode
      errorMessage
      lotsToExport {
        lot
        producerId
        producerName
        remitted
        priced
      }
      exportedLots {
        lot
        producerId
        producerName
        priced
        remitted
      }
    }
  }
`;

export const GET_LOT_SPLIT = gql`
  query getListSplitLot($input: GetListSplitLotRequestInput) {
    getListSplitLot(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        buyer
        buyerName
        producer
        producerName
        haulier
        haulierName
        matrix
        matrixName
        carcs {
          killNo
          earTag
          catName
          conf
          fat
          netWt
          age
          specName
          remark
        }
      }
    }
  }
`;

export const SEARCH_LOTS_SPLIT = gql`
  query searchAssignLot($input: SearchAssignLotRequestInput) {
    searchAssignLot(input: $input) {
      responseCode
      errorCode
      errorMessage
      data
      lotId
    }
  }
`;

export const GET_HAULIER_LIST = gql`
  query getHauliers($input: GetHauliersRequestInput) {
    getHauliers(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      hauliers {
        id
        name
        contact
        postcode
        add1
        add2
        tel
        abmExpiry
        abmMemberNo
      }
    }
  }
`;

export const GET_HAULIER_BY_ID = gql`
  query getHaulierById($input: GetHaulierDetailRequestInput) {
    getHaulierById(input: $input) {
      responseCode
      errorCode
      errorMessage
      haulier {
        id
        name
        contact
        address1
        address2
        address3
        address4
        mobile
        isDefault
        postcode
        fax
        telephone
        emailAddress
        altEmailAddress
        abmMemberShip
        abmMemberNo
        abmExpiry
        created
        createdBy
        updated
        updatedBy
      }
    }
  }
`;
export const GET_SYSTEM_DEFAULT_HAULIER = gql`
  query getDefaultHaulier($input: GetDefaultHaulierRequestInput) {
    getDefaultHaulier(input: $input) {
      responseCode
      errorCode
      errorMessage
      haulier {
        id
        name
      }
    }
  }
`;

export const GET_LIST_DEFAULT_BUYER_HAULIER_MATRIX_FOR_PRODUCER = gql`
  query getListBuyerHaulierMatrixToPro($input: GetListBuyerHaulierMatrixToProRequestInput) {
    getListBuyerHaulierMatrixToPro(input: $input) {
      data {
        species
        buyerDescr
        haulierDescr
        matrixDescr
        buyerId
        haulierId
        matrixId
      }
      responseCode
      errorCode
      errorMessage
    }
  }
`;

export const GET_LOT_INFO = gql`
  query getLotInfoById($input: GetLotInfoRequestInput) {
    getLotInfoById(input: $input) {
      responseCode
      errorCode
      errorMessage
      lotInfo {
        lot
        priced
        pricingComplete
        approved
        remitted
        killDate
        abb
        abbName
        buyer
        buyerName
        haulier
        haulierName
        comments
        species
        matrix
        matrixName
        currency
        remittance
        transportCost
        dressingSpec
        payee
        payeeName
        payeeAddress
        producer
        tradingName
        producerAddress
        producerAdd1
        producerAdd2
        producerAdd3
        producerAdd4
        producerPostcode
        producerCountyName
        useBonus
        rejectComments
        flatRate
        isSelf
        isRemark
      }
    }
  }
`;


export const GET_NON_GROUPED_PRODUCERS = gql`
  query GetNonGroupedProducers($input: GetNonGroupedProducersRequestInput!) {
    getNonGroupedProducers(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalProducers
      producers {
        producerId
        tradingName
        emailAddress
        holdingNumber
        suppliedSites
        suppliedSpecIds
        suppliedCategories
      }
    }
  }
`;

export const GET_BASE_PRICE_LIST = gql`
  query listBasePrices($input: ListBasePricesRequestInput) {
    listBasePrices(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        abb
        basePrices {
          abb
          species
          date
          name
          ageFrom
          ageTo
          weightFrom
          weightTo
          fqas
          organic
          timeOnLastHolding
          maxNumberOfMovements
          minValue
          maxValue
          priority
          value
          matrices {
            id
            descr
          }
          categories {
            id
            descr
          }
          specs {
            id
            descr
          }
          breeds {
            id
            descr
          }
          breedTypes {
            id
            descr
          }
          buyers {
            id
            descr
          }
          producers {
            id
            descr
          }
          prodTypes {
            id
            descr
          }
          countries {
            id
            descr
          }
          origins {
            id
            descr
          }
        }
      }
    }
  }
`;

export const GET_BASE_PRICE_ADJUSTMENT_LIST = gql`
  query listBasePriceAdjustments($input: ListBasePriceAdjustmentsRequestInput) {
    listBasePriceAdjustments(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        species
        name
        ageFrom
        ageTo
        weightFrom
        weightTo
        fqas
        organic
        timeOnLastHolding
        maxNumberOfMovements
        value
        abbs {
          id
          descr
        }
        matrices {
          id
          descr
        }
        categories {
          id
          descr
        }
        specs {
          id
          descr
        }
        breeds {
          id
          descr
        }
        breedTypes {
          id
          descr
        }
        buyers {
          id
          descr
        }
        producers {
          id
          descr
        }
        prodTypes {
          id
          descr
        }
        countries {
          id
          descr
        }
        origins {
          id
          descr
        }
      }
    }
  }
`;

export const GET_PERMISSIONS_TREE = gql`
  query GetPermissionsTree {
    getPermissionsTree {
      responseCode
      errorCode
      errorMessage
      permissions {
        id
        name
        parentId
        prerequisites
        dependencies
        children {
          id
          name
          parentId
          prerequisites
          dependencies
          children {
            id
            name
            parentId
            prerequisites
            dependencies
          }
        }
      }
    }
  }
`;

export const GET_MATRICES = gql`
  query getMatrices($input: GetMatricesRequestInput) {
    getMatrices(input: $input) {
      responseCode
      errorCode
      errorMessage
      matrices {
        id
        name
        matrixType
        matrixTypeName
        gridName
        species
        updated
        updatedBy
      }
    }
  }
`;

export const GET_SELECTED_LIST_DATA_VIA_FRAGMENT = gql`
  {
    Countries: getCountryList {
      ...dropdownListPricing
    }
    Origins: getOrigins {
      ...dropdownListPricing
    }
    Breeds: getBreedAll {
      ...dropdownListPricing
    }
    BreedTypes: getBreedTypeAll {
      ...dropdownListPricing
    }
    Categories: getCategoryList {
      ...dropdownListPricing
    }
    Specs: getSpecList {
      ...dropdownListPricing
    }
    Matrices: getMatricesList {
      ...dropdownListPricing
    }
  }
  ${FRAGMENT_PRICING_LIST_DTO}
`;

export const GET_MATRIX_INPUT = gql`
  query {
    matrixTypes: getMatrixTypeList {
      type
      descr
    }
    grids: getGridList {
      species
      type
      value {
        fat
        conf
      }
    }

    default: getDefaultMatrix {
      id
      name
      species
    }
  }
`;

export const GET_MATRIX_DETAIL = gql`
  query getMatrixAdjustment($input: GetMatrixAdjustmentRequestInput) {
    getMatrixAdjustment(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        matrixId
        matrix
        matrixType
        maxPayWt
        isDefault
        gridName
        id
        name
        categories {
          id
          descr
        }
        specs {
          id
          descr
        }
        breeds {
          id
          descr
        }
        breedTypes {
          id
          descr
        }
        confs {
          id
          descr
        }
        fats {
          id
          descr
        }
        ageFrom
        ageTo
        weightFrom
        weightTo
        value
        adjustmentType
        gradeAdjustmentCells {
          conf
          fat
          value
        }
        maxPayWtAdj
      }
    }
  }
`;

export const GET_MASTER_DATA_FOR_MATRIX = gql`
  {
    Breeds: getBreedAll {
      ...dropdownListPricing
    }
    BreedTypes: getBreedTypeAll {
      ...dropdownListPricing
    }
    Categories: getCategoryList {
      ...dropdownListPricing
    }
    Specs: getSpecList {
      ...dropdownListPricing
    }
    AdjustmentTypes: getAdjustmentTypes {
      ...dropdownListPricing
    }
  }
  ${FRAGMENT_PRICING_LIST_DTO}
`;
export const GET_CHARGES_LIST = gql`
  query getChargesList($input: GetChargesListRequestInput) {
    getChargesList(input: $input) {
      responseCode
      errorCode
      errorMessage
      charges {
        id
        descr
        chargeTypeId
        chargeType
        calcType
        unit
        vatId
        vat
        allowOverride
      }
    }
  }
`;

export const GET_CHARGES_MASTER_DATA = gql`
  {
    ChargeTypes: getChargeTypesList {
      id
      code
      descr
    }
    ChargeVats: getChargeVatsList {
      id
      code
      descr
    }
  }
`;

export const GET_CHARGE_VAT = gql`
  query ChargeVats {
    getChargeVatsList {
      id
      code
      descr
    }
  }
`;

export const SEARCH_BONUS_LIST = gql`
  query searchBonusPayment($input: SearchBonusPaymentRequestInput) {
    searchBonusPayment(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        id
        descr
        calcType
        calcTypeName
        paymentType
        paymentTypeName
        value
        remitText
        showRemitedText
        active
        isLookup
      }
    }
  }
`;

export const GET_MASTER_DATA_FOR_CHARGE_CIRCUMTANCES = gql`
  {
    Breeds: getBreedAll {
      ...dropdownListPricing
    }
    BreedTypes: getBreedTypeAll {
      ...dropdownListPricing
    }
    Categories: getCategoryList {
      ...dropdownListPricing
    }
    Specs: getSpecList {
      ...dropdownListPricing
    }
    AdjustmentTypes: getAdjustmentTypes {
      ...dropdownListPricing
    }
  }
  ${FRAGMENT_PRICING_LIST_DTO}
`;

export const GET_TARGET_TYPES = gql`
  query getChargeTargetTypes {
    getChargeTargetTypes {
      id
      code
      descr
      species
    }
  }
`;

export const GET_LIST_CHARGE_CIRCUMSTANCES = gql`
  query getChargeCircumstances($input: GetChargesCircumstancesRequestInput) {
    getChargeCircumstances(input: $input) {
      responseCode
      errorCode
      errorMessage
      chargeCircumstances {
        chargeId
        chargeDescr
        chargeUnit
        chargeVat
        vatDescr
        vatRate
        targetType
        id
        descr
        species
        speciesDescr
        buyer
        buyerDescr
        breed
        breedDescr
        category
        catDescr
        conditionId
        conditionName
        inspectionTypeId
        inspectionTypeName
        producer
        producerName
        prodType
        prodTypeDescr
        abb
        abbDescr
        ageFrom
        ageTo
      }
    }
  }
`;
export const GET_BONUS_LOOKUP = gql`
  query getBonusPaymentLookup($input: GetBonusPaymentLookupRequestInput) {
    getBonusPaymentLookup(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        condSets {
          id
          species
          ageFrom
          ageTo
          weightFrom
          weightTo
          fqas
          organic
          timeOnLastHolding
          maxNumberOfMovements
          confFatGridName
          abbs {
            id
            descr
          }
          categories {
            id
            descr
          }
          specs {
            id
            descr
          }
          breeds {
            id
            descr
          }
          breedTypes {
            id
            descr
          }
          buyers {
            id
            descr
          }
          producers {
            id
            descr
          }
          origins {
            id
            descr
          }
        }
        matrix {
          bonusLookupId
          bonusLookupCells {
            conf
            fat
            value
          }
        }
      }
    }
  }
`;
export const GET_LIST_DATA_FOR_CHARGE_CIRCUMSTANCES_VIA_FRAGMENT = gql`
  {
    Breeds: getBreedAll {
      ...dropdownListPricing
    }
    Categories: getCategoryList {
      ...dropdownListPricing
    }
  }
  ${FRAGMENT_PRICING_LIST_DTO}
`;

export const GET_INSPECTION_TYPES = gql`
  query getInspectionTypes($input: GetFIRInspectionTypeRequestInput) {
    getInspectionTypes(input: $input) {
      inspectionTypeId
      name
      application
      siteCode
    }
  }
`;

export const GET_FIR_CONDITIONS = gql`
  query getFIRConditions($input: GetFIRConditionRequestInput) {
    getFIRConditions(input: $input) {
      conditonId
      inspectionTypeId
      abb
      name
    }
  }
`;

export const GET_CARCASSES_LIST = gql`
  query getLotCarcass($input: GetLotCarcassesRequestInput) {
    getLotCarcasses(input: $input) {
      responseCode
      errorCode
      errorMessage
      total
      carcasses {
        killNo
        remark
        breed
        breedName
        earTag
        self
        cat
        catName
        conf
        fat
        fqas
        age
        gradeType
        timeOnLastHolding
        spec
        specName
        condWt
        netWt
        payWt
        originalNetWt
        maxPayWt
        ageAdjValue
        gradeAdjValue
        weightAdjValue
        bonusPaymentPpkImmediate
        bonusPaymentValueImmediate
        bonusPaymentValueDeferred
      }
    }
  }
`;

export const GET_BASE_PRICE_FOR_CARCASSES = gql`
  query getLotBasePrices($input: GetLotBasePricesRequestInput) {
    getLotBasePrices(input: $input) {
      responseCode
      errorCode
      errorMessage
      basePrices {
        presetBp
        newBp
        bpOveride
        basePriceName
        quantity
        killNoIds
      }
      basePriceAdjustments {
        basePriceAdjustmentName
        value
        killNoIds
      }
    }
  }
`;

export const GET_MASTER_DATA_FOR_LOT_INFO = gql`
  {
    Categories: getCategoryList {
      ...dropdownListPricing
    }
    Specs: getSpecList {
      ...dropdownListPricing
    }
    Remarks: getBookingRemarks {
      ...dropdownListPricing
    }
  }
  ${FRAGMENT_PRICING_LIST_DTO}
`;

export const GET_CHARGE_LOTS = gql`
  query getChargeLots($input: GetChargeLotsRequestInput) {
    getChargeLots(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        charges {
          chargeId
          descr
          unit
          quantity
          calcType
          vatRate
          vatAmt
          total
          netValue
          allowOverride
        }
        totalSum
        vatAmtSum
        netValueSum
      }
    }
  }
`;

export const GET_ADJ_COLUMN_FOR_CARCASSES = gql`
  query getAdjustmentColumns($input: GetAdjustmentColumnsRequestInput) {
    getAdjustmentColumns(input: $input) {
      responseCode
      errorCode
      errorMessage
      columns {
        reason
        shortDescr
        descr
        showInPricingGrid
        positionOrder
        enabled
      }
    }
  }
`;

export const GET_ADJ_VALUE_FOR_CARCASSES = gql`
  query getManualAdjustments($input: GetManualAdjustmentsRequestInput) {
    getManualAdjustments(input: $input) {
      responseCode
      errorCode
      errorMessage
      adjustments {
        killNo
        reasons {
          reason
          value
        }
        otherAdjustments {
          reason
          value
        }
      }
    }
  }
`;

export const GET_LOT_BONUS_LIST = gql`
  query getLotBonusList($input: GetLotBonusListRequestInput) {
    getLotBonusList(input: $input) {
      responseCode
      errorCode
      errorMessage
      bonuses {
        id
        descr
        calcType
        paymentType
        isLookup
        value
        isApply
      }
    }
  }
`;

export const GET_ROLE_CONFIG_BY_ID = gql`
  query GetRoleConfigs($roleId: UUID!) {
    getRoleConfigs(take: 1, skip: 0, where: { id: { eq: $roleId } }) {
      items {
        id
        name
        description
        active
        permissionIds
        assignedUsers {
          id
          isAssignedSiteUpdate
        }
        isSystemAdmin
      }
      totalCount
    }
  }
`;

export const GET_FOLDER_STRUCTURES = gql`
  query GetFolderStructuresForCms {
    getFolderStructuresForCms {
      responseCode
      errorCode
      errorMessage
      folders {
        id
        name
        description
        path
        parentId
      }
    }
  }
`;

export const GET_FOLDER_STRUCTURES_BY_CMS_USER_ID = gql`
  query GetFolderStructuresForCms {
    getFolderStructuresForCms(input: { isFilteredByUserId: true }) {
      responseCode
      errorCode
      errorMessage
      folders {
        id
        name
        description
        path
        parentId
      }
    }
  }
`;

export const GET_ADJUSTMENT_REASON = gql`
  query {
    getAdjustmentReason {
      responseCode
      errorCode
      errorMessage
      data {
        reason
        species
        descr
      }
    }
  }
`;

export const GET_FOLDER_STRUCTURES_BY_PRODUCER_ID = gql`
  query GetFolderStructures($input: GetFolderStructuresRequestInput) {
    getFolderStructures(input: $input) {
      responseCode
      errorCode
      errorMessage
      folders {
        id
        name
        description
        path
        parentId
      }
    }
  }
`;

export const GET_LOT_APPROVE_LIST = gql`
  query getLotApprove($input: GetLotApproveRequestDtoInput) {
    getLotApprove(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        pending
        approved
        rejected
        total
        lots {
          lot
          species
          producer
          name
          buyer
          lotQty
          approver
          status
          isHightlight
          isHightlightBuyerBladegc
          isHightlightNoManualAdjustmentNegativeBpOvr
          requestNo
          useBonus
          remitted
        }
      }
    }
  }
`;

export const CHECK_EXIST_FOR_MY_DOCUMENT = gql`
  query checkMyDocumentExist($input: CheckMyDocumentExistRequestInput) {
    checkMyDocumentExist(input: $input) {
      errorCode
      errorMessage
      responseCode
    }
  }
`;

export const GET_CARC_LIST_BY_LOT_APPROVAL = gql`
  query getApproveLotCarc($input: GetApproveLotCarcRequestDtoInput) {
    getApproveLotCarc(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        earTag
        killNo
        self
        cat
        conf
        fat
        age
        breed
        specId
        timeOnLastHolding
        netWt
        payWt
        presetBp
        bpOvr
        gradeAdj
        ageAdj
        weightAdj
        manualAdj
        netPkg
        netValue
        bonusValue
        bonusPkg
        carcAdjs {
          adjustmentType
          adjustmentValue
          bonusPaymentType
          author
          created
        }
      }
    }
  }
`;

export const EXPORT_AHDB_REPORT = gql`
  query exportAHDB($input: ExportAHDBRequestInput) {
    exportAHDB(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        killDate
        lot
        killNo
        netValue
      }
    }
  }
`;

export const SEARCH_AUDIT_LOGS = gql`
  query searchAuditLogs($input: SearchAuditLogsInput) {
    searchAuditLogs(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        totalItems {
          totalSuccess
          totalError
        }
        auditLogs {
          id
          userId
          userName
          endPoint
          createdTime
          requestTime
          duration
          status
          method
        }
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getAllUsers {
    getAllUsers {
      responseCode
      calculateSize
      errorCode
      errorMessage
      users {
        userId
        name
        email
      }
    }
  }
`;

export const SEARCH_AUDIT_LOG_DETAIL = gql`
  query searchAuditLogDetail($input: SearchCMSAuditLogDetailRequestInput) {
    searchAuditLogDetail(input: $input) {
      responseCode
      errorCode
      errorMessage
      auditLogDetail {
        id
        userId
        userName
        endPoint
        createdTime
        requestTime
        duration
        status
        method
        requestPayload
        responsePayload
      }
    }
  }
`;

export const GET_BOOKING_FEATURES = gql`
  query GetBookingFeatures($input: GetBookingFeaturesRequestInput!) {
    getBookingFeatures(input: $input) {
      responseCode
      errorCode
      errorMessage
      items {
        id
        name
        isCattle
        isSheep
        abattoirCount
        updated
        updatedBy
      }
    }
  }
`;

export const GET_BOOKING_FEATURE_DETAIL = gql`
  query GetBookingFeatureDetail($input: GetBookingFeatureDetailInput!) {
    getBookingFeatureDetail(input: $input) {
      responseCode
      errorCode
      errorMessage
      feature {
        id
        name
        description
        entryControlType
        species
        placementIds
        abattoirs {
          abb
          species
          isEnabled
        }
        isActive
        updated
        updatedBy
      }
    }
  }
`;

export const GET_ACTIVE_BOOKING_FEATURES_FOR_SITE = gql`
  query GetActiveBookingFeaturesForSite($input: GetActiveBookingFeaturesForSiteInput!) {
    getActiveBookingFeaturesForSite(input: $input) {
      responseCode
      errorCode
      errorMessage
      features {
        id
        name
        entryControlType
        placementIds
      }
    }
  }
`;

export const GET_PRODUCER_DOCUMENT_LOGS = gql`
  query GetProducerDocumentLogs($input: GetProducerDocumentLogsRequestInput!) {
    getProducerDocumentLogs(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      producerDocumentLogs {
        documentId
        producerId
        tradingName
        sites
        fileName
        path
        changeType
        fieldName
        oldValue
        newValue
        updatedDateTime
        updatedBy
      }
    }
  }
`;

export const GET_EMAIL_TYPES = gql`
  query GetEmailTypes($input: GetEmailTypesRequestInput!) {
    getEmailTypes(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      emailTypes {
        id
        name
        noRecipient
      }
    }
  }
`;

export const GET_USER_EMAIL_RECIPIENTS = gql`
  query GetEmailRecipients($input: GetUserRecipientsByEmailTypeRequestInput!) {
    getEmailRecipients(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      totalPage
      users {
        userId
        name
        email
        folders {
          id
          name
        }
        updatedDate
        updatedBy
      }
      emailTypeName
    }
  }
`;

export const GET_LINK_REQUESTS_CMS = gql`
  query GetLinkRequestsCms($input: GetLinkRequestsCmsRequestInput) {
    getLinkRequestsCms(input: $input) {
      responseCode
      errorCode
      errorMessage
      totalCount
      requests {
        id
        requestorDisplayName
        requestedDisplayName
        requestorSites
        requestedSites
        status
        submittedOn
        submittedBy
        updatedDate
        updatedBy
        assignCurrentUser
        pendingApprovers
      }
    }
  }
`;

export const GET_LINK_REQUEST_BY_ID = gql`
  query GetLinkRequestById($input: GetLinkRequestByIdRequestInput!) {
    getLinkRequestById(input: $input) {
      responseCode
      errorCode
      errorMessage
      request {
        id
        requestorName
        requestorId
        requestedId
        requestedName
        status
        notes
        requestedActualTradingName
      }
    }
  }
`;
export const GET_TRANSPORT_COST_PER_HAULIER = gql`
  query getTransportCostPerHaulier($input: GetTransportCostPerHaulierRequestInput!) {
    getTransportCostPerHaulier(input: $input) {
      responseCode
      errorCode
      errorMessage
      transportCostPerHaulier {
        id
        species
        abattoir
        haulierId
        haulierName
        producerId
        producerName
        type
        amount
        vatRateId
        vatRateName
      }
    }
  }
`;

export const GET_TRANSPORT_COST_BOOKING = gql`
  query getTransportCostBooking($input: GetTransportCostBookingRequestInput!) {
    getTransportCostBooking(input: $input) {
      responseCode
      errorCode
      errorMessage
      transportCostBooking {
        transportCostType
        costPerHead
      }
    }
  }
`;

export const GET_CONFIG_MANUAL_ADJUSTMENTS = gql`
  query getConfigManualAdjustment($input: GetConfigManualAdjustmentsRequestInput) {
    getConfigManualAdjustments(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        maxPositionOrder
        adjustments {
          reason
          descr
          shortDescr
          isCattle
          isSheep
          showInPricingGrid
          updated
          updatedBy
          adjustmentAbbs {
            abb
            enabled
            positionOrder
          }
        }
      }
    }
  }
`;

export const GET_PRODUCER_ACTIVITIES = gql`
  query getProducerActivities($input: GetProducerActivitiesRequestInput) {
    getProducerActivities(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        totalCount
        activities {
          species
          abattoir
          abbCode
          lot
          lotAccessible
          killDate
          quantity
          buyer
          haulier
          netWeight
          netValue
          isHistorical
        }
      }
    }
  }
`;

export const GET_EARTAG_SEARCH_CARCASS = gql`
  query GetEartagSearchCarcass($input: GetEartagSearchCarcassRequestInput) {
    getEartagSearchCarcass(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        totalCount
        eartagSearchCarcass_ {
          eartag
          lot
          abattoir
          killDate
          killNo
          producer
          name
          category
          breed
          conf
          fat
          age
          condWt
          netWt
          payWt
          netPkg
          netValue
          species
          isHistorical
        }
      }
    }
  }
`;

export const GET_EARTAG_SEARCH_MOVEMENT = gql`
  query GetEartagSearchMovement($input: EartagSearchMovementRequestInput!) {
    getEartagSearchMovement(input: $input) {
      responseCode
      errorCode
      errorMessage

      data {
        totalCout

        eartagSearchMovementData {
          eartag
          lot
          killdate
          movementId
          holdingNo
          onHolding
          offHolding
          totalDaysOnHolding
          fqas
          country
        }
      }
    }
  }
`;

export const GET_PASS_MOVEMENT_BY_EARTAG = gql`
  query GetPassmovementByEartag($input: GetPassmovementByEartagRequestInput) {
    getPassmovementByEartag(input: $input) {
      responseCode
      errorCode
      errorMessage
      data {
        eartag
        lot
        species
        abattoir
        killDate
        movementId
        holdingNo
        onHolding
        offHolding
        totalDaysOnHolding
        fqas
        country
      }
    }
  }
`;

export const GET_SCHEME_MEMBERS = gql`
  query getSchemeMembers($getSchemeMembersInput: GetSchemeMembersRequestInput) {
    getSchemeMembers(getSchemeMembersInput: $getSchemeMembersInput) {
      responseCode
      errorCode
      errorMessage
      totalCount
      items {
        producerId
        tradingName
        holdingNumber
        sites
        lastUpdated
        updatedBy
      }
    }
  }
`;

export const SEARCH_SCHEME_MEMBER_PRODUCERS = gql`
  query searchSchemeMemberProducers($searchSchemeMemberProducersInput: SearchSchemeMemberProducersRequestInput) {
    searchSchemeMemberProducers(searchSchemeMemberProducersInput: $searchSchemeMemberProducersInput) {
      responseCode
      errorCode
      errorMessage
      totalCount
      items {
        producerId
        tradingName
      }
    }
  }
`;
